<div class="atp-notification__data">
  <div class="atp-notification__header">
    <h5>{{data.data.title}}</h5>
    <button mat-icon-button (click)="closeClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div>
    <ng-container *ngFor="let span of spans; let i = index">
      <span [innerText]="span"></span>
      <a *ngIf="links.length > i" [routerLink]="links[i]">{{linkNames[i]}}</a>
    </ng-container>
  </div>
</div>